"use client"

import { ParserListPage } from "@/components/extractor/parsers/ParserListPage"

export default function ExtractorDashboard() {
  return <ParserListPage />
}
